import { Col, Input, Row } from "reactstrap";
import styles from "./WarehouseDetail.module.scss";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";

const WarehouseDetail = () => {
  return (
    <div className="py-3">
      <div className={styles["heading"]}>Warehouse Detail</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Name:</Col>
            <Col lg={5} xxl={4}>
              <Input placeholder="Enter name of the product" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1">
            <Col lg={3} xxl={2}>Address:</Col>
            <Col lg={5} xxl={4}>
              <Input type="textarea" placeholder="Enter Address" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Phone number:</Col>
            <Col lg={5} xxl={4}>
              <Input type="number" placeholder="Enter phone" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Email Address:</Col>
            <Col lg={5} xxl={4}>
              <Input type="text" placeholder="Enter email" />
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>Country:</Col>
            <Col lg={5} xxl={4}>
              <div className="border rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>State:</Col>
            <Col lg={5} xxl={4}>
              <div className="border rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xxl={2}>City:</Col>
            <Col lg={5} xxl={4}>
              <div className="border rounded p-2">
                <CustomDropdown title={"Select from dropdown"} muted />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default WarehouseDetail;